import React from 'react';
import { SEO } from '../components/SEO';
import { PersonalHero } from '../components/PersonalHero';
import { StatsBar } from '../components/StatsBar';
import { StorySection } from '../components/StorySection';
import { JourneyTimeline } from '../components/JourneyTimeline';
import { UniqueValue } from '../components/UniqueValue';
import { ResultsSection } from '../components/ResultsSection';
import { PhilosophySection } from '../components/PhilosophySection';
import { FinalCTA } from '../components/FinalCTA';
export function HomePage() {
  return <>
      <SEO title="Justus Kraft - CRM Expert | Sales Automation Specialist" description="Started my first business at 16. Now at 23, I help companies double their sales through intelligent CRM systems. 110+ happy clients, GDPR compliant, $7M+ in additional revenue generated." keywords="CRM expert, sales automation, CRM consulting, Justus Kraft, B2B sales, B2C sales, CRM systems, sales optimization, revenue growth, lead management" data-id="element-325" data-mp="2rzbdbf9g248v" />
      <main data-id="element-326" data-mp="2ao3jmhzhawkr">
        <PersonalHero data-id="element-327" data-mp="2aoda06ofr5qz" />
        <StatsBar data-id="element-328" data-mp="2an27sban261z" />
        <StorySection data-id="element-329" data-mp="2eq8bbb6d9j4r" />
        <JourneyTimeline data-id="element-330" data-mp="2epovq146v6tw" />
        <UniqueValue data-id="element-331" data-mp="2eox93fskkjfr" />
        <ResultsSection data-id="element-332" data-mp="2eo3xo1io15ra" />
        <PhilosophySection data-id="element-333" data-mp="2jhgngez2zilm" />
        <FinalCTA data-id="element-334" data-mp="2ji86yrfelpvj" />
      </main>
    </>;
}